import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n)

const
    languages = ['en', 'es'],
    defaultLang = 'en',
    modules = {},
    files = require.context('.', false, /\.js$/),
    pathData = window.location.pathname.replace(/^\/|\/$/g, '').split('/'),
    locale = (languages.includes(pathData[0])) ? pathData[0] : defaultLang;

files.keys().forEach((key) => {
    if (key === './index.js') return
    modules[ key.replace(/(\.\/|\.js)/g, '') ] = files(key).default
})

export default new VueI18n({
    locale: locale,
    fallbackLocale: defaultLang,
    messages: modules,
});